import { ResortDetail, ResortInventory } from "../../models/presentation.model";

export class ResortInformation{
    detail: ResortDetail;
    inventory: ResortInventory;
    propertyImageUrl: String;
    unitImageUrl : String;
    roomTitle: String;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/resort-information/resort-information.model.ts